<template>
  <div class="form-container">
    <form class="formulario">
      <div class="btnContainer">
        <Button
          class="btn back"
          label="Volver"
          icon="pi pi-arrow-left"
          @click="handleBackToMainForm"
          v-if="hideSaveAndBackInternalButtons !== true"
        />
        <Button
          class="btn save"
          label="Guardar"
          icon="pi pi-check"
          @click="handleSave"
          test-id="buttonSaveUbicacion"
          :disabled="!isFormValid"
          v-if="hideSaveAndBackInternalButtons !== true"
        />
      </div>
      <!-- Primera fila -->
      <div class="fila">
        <div class="campo" style="gap: 0">
          <label test-id="textDesdeLabel" style="padding-bottom: 7px">
            Desde <span style="color: red">*</span>
          </label>
          <div>
            <CustomCalendar
              v-if="enableField('date')"
              id="time24"
              class="input"
              :selectOtherMonths="true"
              onkeydown="return false;"
              :showTime="true"
              placeholder="Desde fecha y hora"
              dateFormat="dd/mm/yy"
              v-model="formData.date"
              :maxDate="today"
              test-id="desdeCalendar"
              :timeByKeyboard="true"
              :disabled="viewMode === true"
              ref="CustomCalendarFrom"
            >
              <template #footer>
                <div class="flex justify-content-between">
                  <Button
                    label="Hoy"
                    icon="pi pi-check"
                    class="p-button-text w-6rem"
                    @click="setToNow('date')"
                  />
                  <Button
                    label="Cerrar"
                    icon="pi pi-times"
                    class="p-button-text w-6rem"
                    @click="closeCalendar('CustomCalendarFrom')"
                  />
                </div>
              </template>
            </CustomCalendar>
          </div>
          <label :class="{ visible: errores.date }" style="color: red; margin-top: 10px">
            {{ errores.date }}
          </label>
        </div>

        <div class="campo" style="gap: 0">
          <label test-id="textHastaLabel" style="padding-bottom: 7px">
            Hasta <span style="color: red">*</span>
          </label>
          <div>
            <CustomCalendar
              v-if="enableField('date2')"
              id="basic"
              class="input"
              :selectOtherMonths="true"
              onkeydown="return false;"
              :showTime="true"
              placeholder="Hasta fecha y hora"
              dateFormat="dd/mm/yy"
              v-model="formData.date2"
              :maxDate="today"
              test-id="hastaCalendar"
              :timeByKeyboard="true"
              :disabled="viewMode === true"
              ref="CustomCalendarTo"
            >
              <template #footer>
                <div class="flex justify-content-between">
                  <Button
                    label="Hoy"
                    icon="pi pi-check"
                    class="p-button-text w-6rem"
                    @click="setToNow('date2')"
                  />
                  <Button
                    label="Cerrar"
                    icon="pi pi-times"
                    class="p-button-text w-6rem"
                    @click="closeCalendar('CustomCalendarTo')"
                  />
                </div>
              </template>
            </CustomCalendar>
          </div>
          <label :class="{ visible: errores.date2 }" style="color: red; margin-top: 10px">
            {{ errores.date2 }}
          </label>
        </div>

        <div class="campo" style="gap: 0">
          <label for="departamento" style="padding-bottom: 7px">
            Departamento <span style="color: red">*</span>
          </label>
          <Dropdown
            class="input"
            dataKey="nombre"
            v-model="formData.departamento"
            :options="departamentos"
            optionLabel="nombre"
            placeholder="Departamento"
            test-id="buttonDepartamento"
            :filter="true"
            @blur="handleBlur('departamento')"
            :disabled="viewMode === true"
          />
          <label
            :class="{ visible: shouldShowError('departamento') && errores.departamento }"
            style="color: red"
          >
            {{ shouldShowError("departamento") ? errores.departamento : "" }}
          </label>
        </div>
      </div>

      <!-- Segunda fila -->
      <div class="fila">
        <div class="campo">
          <label for="calle"> Calle <span style="color: red">*</span> </label>
          <InputText
            class="input"
            id="calle"
            type="text"
            placeholder="Calle"
            v-model="formData.calle"
            @blur="handleBlur('calle')"
            test-id="inputCalle"
            :disabled="viewMode === true"
          />
          <label :class="{ visible: shouldShowError('calle') && errores.calle }" style="color: red">
            {{ shouldShowError("calle") ? errores.calle : "" }}
          </label>
        </div>

        <div class="campo">
          <label for="numero"> Número <span style="color: red">*</span> </label>
          <InputText
            class="input"
            id="numero"
            type="number"
            placeholder="Número"
            v-model="formData.numero"
            @blur="handleBlur('numero')"
            test-id="inputNumero"
            :disabled="viewMode === true"
          />
          <label
            :class="{ visible: shouldShowError('numero') && errores.numero }"
            style="color: red"
          >
            {{ shouldShowError("numero") ? errores.numero : "" }}
          </label>
        </div>

        <div class="campo">
          <label for="numero"> Ubicación <span style="color: red">*</span> </label>
          <div>
            <CustomAutoComplete
              class="input"
              v-model="formData.ubication"
              :suggestions="ubicationSuggestions"
              v-on:focus="onFocusEvent()"
              @complete="searchUbication($event)"
              placeholder="Ubicación"
              field="display_name"
              ref="ubicationRef"
              id="ubicationID"
              test-id="inputUbicacion"
              @selectItem="(suggestion) => selectASuggestion(suggestion)"
              @blur="customAutoCompleteBlur($event)"
              :disabled="viewMode === true"
            >
              <template #item="slotProps">
                <div @click="selectASuggestion(slotProps.item)">
                  {{ slotProps.item.display_name }}
                </div>
              </template>
            </CustomAutoComplete>
          </div>
          <label :class="{ visible: shouldShowError('ubicacion') && errores.ubicacion }">
            {{ shouldShowError("ubicacion") ? errores.ubicacion : "" }}
          </label>
        </div>
      </div>

      <!-- Tercera fila -->
      <div class="fila">
        <div class="campo">
          <label for="numero"> Latitud <span style="color: red">*</span> </label>
          <div class="input-icon">
            <InputText
              class="input"
              id="Lat"
              type="text"
              v-model="formData.Lat"
              :disabled="true"
              @blur="handleBlur('Lat')"
            />
            <div class="i-with-tooltip">
              <CustomTooltip
                title="Editar campo"
                text="Editá este dato desde el mapa con el botón Editar mapa."
                placement="bottom"
                triggerType="hover"
                :showCloseIcon="true"
              >
                <i
                  class="pi pi-exclamation-circle"
                  style="width: 16px; height: 16px; color: #0c5295"
                ></i>
              </CustomTooltip>
            </div>
          </div>
          <label :class="{ visible: shouldShowError('Lat') && errores.Lat }" style="color: red">
            {{ shouldShowError("Lat") ? errores.Lat : "" }}
          </label>
        </div>

        <div class="campo">
          <label for="numero"> Longitud <span style="color: red">*</span> </label>
          <div class="input-icon">
            <InputText
              class="input"
              id="Long"
              type="text"
              v-model="formData.Long"
              :disabled="true"
              @blur="handleBlur('Long')"
            />
            <div class="i-with-tooltip">
              <CustomTooltip
                title="Editar campo"
                text="Editá este dato desde el mapa con el botón Editar mapa."
                placement="bottom"
                triggerType="hover"
                :showCloseIcon="true"
              >
                <i
                  class="pi pi-exclamation-circle"
                  style="width: 16px; height: 16px; color: #0c5295"
                ></i>
              </CustomTooltip>
            </div>
          </div>
          <label :class="{ visible: shouldShowError('Long') && errores.Long }" style="color: red">
            {{ shouldShowError("Long") ? errores.Long : "" }}
          </label>
        </div>
      </div>

      <div class="formulario" style="margin-top: 1em">
        <div class="fila">
          <div class="campo">
            <label for="casa"> Casa: </label>
            <InputText
              v-no-emoji
              id="casa"
              type="text"
              placeholder="Número/Letra"
              v-model="formData.casa"
              test-id="casa"
              @blur="handleBlur('casa')"
              :disabled="viewMode === true"
            />
            <label :class="{ visible: errores.casa }" style="color: red">
              {{ errores.casa }}
            </label>
          </div>

          <div class="campo" style="margin-bottom: 10px">
            <label for="orientacion"> Orientación: </label>
            <Dropdown
              dataKey="nombre"
              v-model="formData.orientacion"
              :options="optionsOrientation"
              optionLabel="nombre"
              :filter="true"
              test-id="orientacion"
              placeholder="Elija orientación"
              style="height: 36px"
              @blur="handleBlur('orientacion')"
              :disabled="viewMode === true"
            />
          </div>

          <div class="campo">
            <label for="sector">Sector: </label>
            <InputText
              v-no-emoji
              id="sector"
              type="text"
              placeholder="Número/Letra/Nombre"
              v-model="formData.sector"
              test-id="sector"
              @blur="handleBlur('sector')"
              :disabled="viewMode === true"
            />
            <label :class="{ visible: errores.sector }" style="color: red">
              {{ errores.sector }}
            </label>
          </div>
        </div>

        <div class="fila">
          <div class="campo">
            <label for="piso">Piso: </label>
            <InputText
              v-no-emoji
              id="piso"
              type="text"
              placeholder="Número"
              v-model="formData.piso"
              test-id="piso"
              @blur="handleBlur('piso')"
              :disabled="viewMode === true"
            />
            <label :class="{ visible: errores.piso }" style="color: red">
              {{ errores.piso }}
            </label>
          </div>

          <div class="campo">
            <label for="barrio">Barrio: </label>
            <InputText
              v-no-emoji
              id="barrio"
              type="text"
              placeholder="Nombre"
              v-model="formData.barrio"
              test-id="barrio"
              @blur="handleBlur('barrio')"
              :disabled="viewMode === true"
            />
            <label :class="{ visible: errores.barrio }" style="color: red">
              {{ errores.barrio }}
            </label>
          </div>

          <div class="campo">
            <label for="zona">Zona: </label>
            <InputText
              v-no-emoji
              id="zona"
              type="text"
              placeholder="Número/Nombre"
              v-model="formData.zona"
              test-id="zona"
              @blur="handleBlur('zona')"
              :disabled="viewMode === true"
            />
            <label :class="{ visible: errores.zona }" style="color: red">
              {{ errores.zona }}
            </label>
          </div>
        </div>
      </div>
    </form>

    <div class="mapa">
      <MyMap
        id="map"
        ref="map"
        :initial-position="rememberedCoordinates"
        @updateCoordinates="handleUpdateCoordinates"
        :calledFromviewMode="props.calledFromviewMode"
        :editMode="props.editMode"
      />
    </div>

    <CustomModal
      :title="
        customButtons
          ? 'Estás por salir sin guardar los cambios'
          : '¿Estás seguro de que quieres volver?'
      "
      modalType="warning"
      :message="modalMessage"
      :button-labels="
        customButtons ? ['Salir sin guardar', 'Seguir cargando'] : ['Volver', 'Seguir cargando']
      "
      @confirm="restableshingToOriginalForm"
      @cancel="cancelBack"
      ref="modalRefSave"
    />
    <CustomModal
      title="¡Los datos se guardaron con éxito!"
      modalType="success"
      :message="modalMessage"
      :showSecondaryButton="false"
      @confirm="handleRedirect"
      :button-labels="[props.calledFromViewMode ? 'Continuar' : 'Volver']"
      ref="modalRefSaveSuccess"
    />
    <CustomModal
      title="¡Error al guardar!"
      modalType="error"
      message="Error al guardar la actuación. Intente nuevamente."
      :showSecondaryButton="false"
      @confirm="handleErrorModal"
      :button-labels="['Reintentar']"
      ref="modalRefDateAndLocationError"
    />
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, nextTick } from "vue";
import { useStoreCompat, useRouterCompat } from "@/composables";
import { useActuacionWizardStore } from "@/store/Pinia/useActuacionWizardStore";
import MyMap from "../MyMap.vue";
import CustomCalendar from "../custom-calendar/CustomCalendar.vue";
import CustomAutoComplete from "../../components/custom-autocomplete/CustomAutoComplete.vue";
import * as AltaDenuncia from "@/data/sumario_denuncia_alta";
import { useDatesAndLocationsStore } from "@/store/Pinia/useDatesAndLocationsStore";
import CustomModal from "../CustomModal.vue";

const props = defineProps([
  "modelo",
  "factory",
  "formType",
  "errors",
  "hideSaveAndBackInternalButtons",
  "calledFromviewMode",
  "editMode",
  "viewMode",
  "wizardSync",
  // "categorizeErrors",
]);

const emit = defineEmits(["cancelSave", "save", "disableSaveButton"]);

const store = useStoreCompat();
const { router } = useRouterCompat();
const wizard = useActuacionWizardStore();

let formData = ref({
  date: "",
  date2: "",
  departamento: "",
  calle: "",
  numero: "",
  ubication: "",
  Lat: "",
  Long: "",
  casa: "",
  orientacion: "",
  sector: "",
  piso: "",
  barrio: "",
  zona: "",
});
const CustomCalendarFrom = ref(null);
const CustomCalendarTo = ref(null);
const fieldTouched = ref({
  calle: false,
  numero: false,
  departamento: false,
  ubicacion: false,
  Lat: false,
  Long: false,
  date: false,
  date2: false,
});
const ubicationSuggestions = ref([]);
const ubicationRef = ref(null);
const map = ref(null);
const optionsOrientation = ref([
  { id: 0, nombre: "Norte" },
  { id: 1, nombre: "Sur" },
  { id: 2, nombre: "Este" },
  { id: 3, nombre: "Oeste" },
]);
const modalMessage = ref("");
const modalRefSave = ref(null);
const modalRefSaveSuccess = ref(null);
const modalRefDateAndLocationError = ref(null);
const customButtons = ref(false);
const showAllErrors = ref(false);
let datesAndLocationsStore = ref(null);

const generateMomentAndPreUbicacion = () => {
  const momentData = {
    date: formData.value.date,
    date2: formData.value.date2,
  };

  const preUbicacionData = {
    calle: formData.value.calle,
    coordinates: {
      lat: formData.value.Lat,
      lng: formData.value.Long,
    },
    departamento: formData.value.departamento,
    numero: formData.value.numero,
    barrio: formData.value.barrio || "",
    casa: formData.value.casa || "",
    orientacion: formData.value.orientacion || {},
    piso: formData.value.piso || "",
    sector: formData.value.sector || "",
    zona: formData.value.zona || "",
  };

  return { momentData, preUbicacionData };
};

const ubicationDetailsEmpty = (ubication) => {
  let empty = ["casa", "orientacion", "sector", "piso", "barrio", "zona"].some((field) => {
    const val = ubication[field];

    if (typeof val === "string") {
      return val.trim() !== "";
    }

    if (val && typeof val === "object") {
      return Object.keys(val).length > 0;
    }
    return Boolean(val);
  });
  return !empty;
};

const today = computed(() => new Date());
const sumario = computed(() => store.state.sumario || {});
const departamentos = computed(() => store.state.siis?.ubicacion?.departamentos || []);
let ubicacion = computed(() => store.state[props.modelo]?.preUbicacion || []);
let moment = computed(() => store.state[props.modelo]?.preMoment || {});

const enableField = computed(() => (v) => {
  if (!props || !props.factory) return true;
  return props.factory.includes(`{${v}}`);
});

const errores = computed(() => ({
  calle:
    formData.value?.calle === ""
      ? "Este campo es obligatorio"
      : formData.value?.calle.length > 100
        ? "Máximo 100 caracteres"
        : null,
  departamento: !formData.value?.departamento ? "Departamento es obligatorio" : null,
  numero:
    formData.value?.numero === ""
      ? "Este campo es obligatorio"
      : formData.value?.numero.length > 45
        ? "Máximo 45 caracteres"
        : null,
  casa: formData.value?.casa && formData.value?.casa.length > 20 ? "Máximo 20 caracteres" : null,
  sector:
    formData.value?.sector && formData.value?.sector.length > 20 ? "Máximo 20 caracteres" : null,
  piso: formData.value?.piso && formData.value?.piso.length > 20 ? "Máximo 20 caracteres" : null,
  barrio:
    formData.value?.barrio && formData.value?.barrio.length > 20 ? "Máximo 20 caracteres" : null,
  zona: formData.value?.zona && formData.value?.zona.length > 20 ? "Máximo 20 caracteres" : null,
  ubicacion: formData.value?.ubication === "" ? "Este campo es obligatorio" : null,
  Lat: formData.value?.Lat ? null : "Falta geolocalización",
  Long: formData.value?.Long ? null : "Falta geolocalización",
  date: erroresDates.value.date,
  date2: erroresDates.value.date2,
}));

const setFormData = (lugar, momento) => {
  let departamentoObj = lugar?.departamento;
  if (typeof departamentoObj === "string") {
    departamentoObj = departamentos.value.find((dept) => dept.nombre === departamentoObj) || null;
  }

  formData.value = {
    date: momento?.date,
    date2: momento?.date2,
    departamento: departamentoObj,
    calle: lugar?.calle ?? "",
    numero: lugar?.numero ?? "",
    Lat: lugar?.coordinates?.lat,
    Long: lugar?.coordinates?.lng,
    casa: lugar?.casa ?? "",
    orientacion: lugar?.orientacion ?? {},
    sector: lugar?.sector ?? "",
    piso: lugar?.piso ?? "",
    barrio: lugar?.barrio ?? "",
    zona: lugar?.zona ?? "",
  };
};

const rememberedSearch = (coordinates) => {
  if (map.value) {
    map.value.setPosition({
      lat: coordinates.lat,
      lng: coordinates.lng,
    });
  }
};

const rememberedCoordinates = computed({
  get: () => ubicacion.value.coordinates || null,
  set: (value) => {},
});

onMounted(async () => {
  datesAndLocationsStore = useDatesAndLocationsStore();
  if (props.wizardSync) {
    await nextTick();
    try {
      const stored = wizard.fecha?.data;
      if (stored && (stored.preUbicacion || stored.preMoment)) {
        setFormData(stored.preUbicacion, stored.preMoment);
        await nextTick();
        const coords = stored.preUbicacion?.coordinates;
        if (coords && coords.lat != null && coords.lng != null) {
          rememberedSearch(coords);
        }
      }
    } catch {}
    await nextTick();
    syncWizard();

    watch(
      () => formData.value,
      () => {
        nextTick(() => syncWizard());
      },
      { deep: true, flush: "post" }
    );

    watch(
      () => isFormValid.value,
      (valid) => {
        wizard.setStepValid("fecha", !!valid);
      },
      { immediate: true }
    );
  } else {
    if (ubicacion.value.calle) {
      setFormData(ubicacion.value, moment.value);
      await nextTick();
    }
    if (rememberedCoordinates.value) {
      rememberedSearch(rememberedCoordinates.value);
    }
  }

  if (props.viewMode === true) {
    // Si departamento es string, convertirlo a objeto
    if (typeof formData.value.departamento === "string") {
      formData.value.departamento = AltaDenuncia.default.departamentos.find(
        (deparment) => deparment.nombre === formData.value.departamento
      );
      formData.value.orientacion = {
        id: formData.value.orientacion,
        nombre: formData.value.orientacion,
      };
    }
    await nextTick();
  }
});

const fullAddress = computed(() => {
  const parts = [];
  const { calle, numero, departamento } = formData.value;
  if (calle) parts.push(calle);
  if (numero) parts.push(numero);

  const depto = departamento?.nombre;
  if (depto && depto !== "Sin Departamento") parts.push(depto);

  return parts.join(" ");
});

watch(
  fullAddress,
  (newAddress) => {
    formData.value.ubication = newAddress;
  },
  {
    immediate: true,
    deep: true,
  }
);

if (!props.wizardSync) {
  watch(
    () => store.state[props.modelo]?.preUbicacion,
    async (newValue) => {
      if (newValue !== undefined && newValue.calle) {
        // Solo actualizar si hay datos y si el departamento actual no es ya un objeto válido
        let preUbicacionUpdated = { ...store.state[props.modelo]?.preUbicacion };

        // Solo procesar si el departamento es un string (no es ya un objeto)
        if (typeof preUbicacionUpdated.departamento === "string") {
          preUbicacionUpdated.departamento =
            store.state.siis?.ubicacion?.departamentos.find(
              (obj) => obj.nombre === preUbicacionUpdated.departamento
            ) || null;
        }

        // Solo procesar orientación si es un string
        if (typeof preUbicacionUpdated.orientacion === "string") {
          preUbicacionUpdated.orientacion =
            [
              { id: 0, nombre: "Norte" },
              { id: 1, nombre: "Sur" },
              { id: 2, nombre: "Este" },
              { id: 3, nombre: "Oeste" },
            ].find((obj) => obj.nombre === preUbicacionUpdated.orientacion) || null;
        }

        setFormData(preUbicacionUpdated, store.state[props.modelo]?.preMoment);
      }
    },
    { immediate: true, deep: true, flush: "post" }
  );
}

const erroresDates = computed(() => {
  const errors = { date: null, date2: null };
  const { date, date2 } = formData.value;
  if (date && date2 && date > date2) {
    if (date > date2) {
      errors.date = "La fecha Desde no puede ser mayor que la fecha de Hasta";
      errors.date2 = "La fecha Hasta no puede ser menor que la fecha de Desde";
    }
  }
  return errors;
});

const isFormValid = computed(() => {
  const requiredFields = [
    formData.value.calle,
    formData.value.numero,
    !!formData.value.departamento,
    formData.value.Lat,
    formData.value.Long,
    formData.value.date,
    formData.value.date2,
    formData.value.ubication,
  ];

  if (requiredFields.some((field) => !field)) return false;

  return !Object.values(errores.value).some((error) => error !== null);
});

// Función de sincronización con el wizard
const syncWizard = () => {
  if (!props.wizardSync) return;
  try {
    const { momentData, preUbicacionData } = generateMomentAndPreUbicacion();
    // Persistimos datos y validez en el wizard
    wizard.setStepData("fecha", { preUbicacion: preUbicacionData, preMoment: momentData });
    wizard.setStepValid("fecha", !!isFormValid.value);
  } catch (e) {
    console.error("Error syncing wizard:", e);
  }
};

defineExpose({
  modalRefSave,
  modalRefSaveSuccess,
  modalMessage,
  customButtons,
  modalRefDateAndLocationError,
  generateMomentAndPreUbicacion,
  ubicationDetailsEmpty,
  isFormValid,
});

const shouldShowError = (field) => {
  return fieldTouched.value[field] || showAllErrors.value;
};

const handleBlur = (field) => {
  if (field == "numero" || field == "calle") {
    if (formData?.value[field] === "") {
      emit("disableSaveButton", true);
    } else {
      emit("disableSaveButton", false);
    }
  }
  fieldTouched.value[field] = true;
};

const setToNow = (vModel) => {
  if (vModel === "date") formData.value.date = today.value;
  if (vModel === "date2") formData.value.date2 = today.value;
};

const closeCalendar = (calendarType) => {
  if (calendarType === "CustomCalendarFrom" && CustomCalendarFrom.value) {
    CustomCalendarFrom.value.overlayVisible = false;
  }
  if (calendarType === "CustomCalendarTo" && CustomCalendarTo.value) {
    CustomCalendarTo.value.overlayVisible = false;
  }
};

const onFocusEvent = () => {
  const input = document.getElementById("ubicationID");
  if (input) input.dispatchEvent(new Event("input"));
};

const searchUbication = async () => {
  const searchUrl = "https://nominatim.openstreetmap.org/search?format=json&q=";
  const addressToSearch = `${formData.value.ubication}, San Juan, Argentina`;

  try {
    const response = await fetch(`${searchUrl}${encodeURI(addressToSearch)}`);
    ubicationSuggestions.value = await response.json();
  } catch (error) {
    console.error("Error fetching location:", error);
    ubicationSuggestions.value = [];
  }
};

const selectASuggestion = (suggestion) => {
  locateOnMap(suggestion);
  formData.value.ubication = suggestion.display_name;

  const input = document.getElementById("ubicationID");
  if (input) input.value = suggestion.display_name;
};

const customAutoCompleteBlur = (e) => {
  formData.value.ubication = e.target.value;
};

const locateOnMap = (searchOnMap) => {
  if (map.value) {
    map.value.setPosition({
      lat: parseFloat(searchOnMap.lat),
      lng: parseFloat(searchOnMap.lon),
    });
  }

  rememberedCoordinates.value = {
    lat: parseFloat(searchOnMap.lat),
    lng: parseFloat(searchOnMap.lon),
  };

  formData.value.Lat = parseFloat(searchOnMap.lat);
  formData.value.Long = parseFloat(searchOnMap.lon);
};

const handleUpdateCoordinates = (coordinates) => {
  formData.value.Lat = Number(coordinates.lat);
  formData.value.Long = Number(coordinates.lng);
  rememberedCoordinates.value = coordinates;
};

const handleSave = () => {
  const momentData = generateMomentAndPreUbicacion()?.momentData;
  const preUbicacionData = generateMomentAndPreUbicacion()?.preUbicacionData;
  store.dispatch(`${props.modelo}/setMoment`, momentData);
  store.dispatch(`${props.modelo}/setPreMoment`, momentData);
  store.dispatch(`${props.modelo}/setPreUbicacion`, preUbicacionData);
  const currentPath = router.currentRoute.path.split("/");
  if (!currentPath.includes("denuncia")) {
    store.dispatch("sumario/textResetEditsCounter", "Preform");
  }
  store.dispatch("sumario/textResetEditsCounter", "Preform");
  modalMessage.value =
    "La información se ha guardado correctamente. Para regresar a la página anterior, haga click en 'Volver'.";
  modalRefSaveSuccess.value.open();
};

const handleRedirect = () => {
  if (props?.calledFromviewMode === true)
    setFormData(
      datesAndLocationsStore.dateAndLocation.preUbicacion,
      datesAndLocationsStore.dateAndLocation.moment
    );
  emit("save");
};

const handleErrorModal = () => {
  emit("retry");
};

const handleBackToMainForm = () => {
  modalMessage.value =
    "¿Estás seguro de que quieres volver?  Si decides continuar, se perderán todos los datos que no hayas guardado. Guarda los datos antes de volver para evitar la pérdida de información.";
  modalRefSave.value.open();
};

const restableshingToOriginalForm = () => {
  if (props.calledFromviewMode === true) {
    if (datesAndLocationsStore?.dateAndLocation?.preUbicacion?.coordinates?.lat !== undefined) {
      // Si fue modificado al menos 1 vez, reestablecemos los valores a los actualizados
      setFormData(
        datesAndLocationsStore.dateAndLocation.preUbicacion,
        datesAndLocationsStore.dateAndLocation.moment
      );
    } else {
      // Si nunca fue modificado, reestablecemos a los valores originales
      setFormData(ubicacion.value, moment.value);
    }
  }
  customButtons.value = false;
  emit("cancelSave");
};

const cancelBack = () => {
  modalRefSave.value.close();
  modalRefSaveSuccess.value.close();
  customButtons.value = false;
};
</script>

<style scoped>
.form-container {
  padding: 20px;
  max-width: 1200px;
  margin: auto;
  width: 100%;
  color: #0b5195;
}

.formulario {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.fila {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  align-items: flex-start;
}

.campo {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 180px;
  justify-content: flex-end;
  gap: 10px;
}

.input {
  width: 100%;
  border: 1px solid #0b5195;
  border-radius: 6px;
}

input,
select {
  padding: 6px 8px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

>>> .p-inputtext {
  height: 35px;
  border-radius: 6px;
  display: flex;
  align-items: center;
}

.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  width: 120px;
  height: 36px;
}

.save {
  align-self: flex-end;
  background-color: #0b5195;
  color: white;
}

.back {
  align-self: flex-end;
  background-color: #ffffff;
  color: #0b5195;
  border: 1px solid #0b5195;
}

.btnContainer {
  position: absolute;
  right: 20px;
  top: 90px;
  display: flex;
  gap: 10px;
}

.save:hover {
  background-color: #003070;
}

.back:hover {
  background-color: #ffffff;
  color: #0b5195;
}

.mapa {
  height: 400px;
  margin-top: 20px;
}

>>> #ubicationID {
  width: 100%;
}

.input-icon {
  position: relative;
  display: inline-block;
  width: 100%;
}

.input-icon input {
  padding-right: 2rem; /* espacio para el ícono */
}

.i-with-tooltip {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-45%);
  color: #6c757d;
  cursor: pointer;
}
</style>
